var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","ontouchstart":""}},[_c('router-view'),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"audio","src":require("@/assets/MP3.mp3")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }